"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCustoHook = void 0;
const react_1 = require("react");
const hook_1 = require("../hook");
const errors_1 = require("../../utils/errors");
function buildCustoHook(hook, path, defaultValue) {
    return hook_1.CustoHook.createRawDataHook((...args) => {
        const val = useVl(hook(), defaultValue, path);
        const value = val.use(...args);
        const isValueCustoHook = value instanceof hook_1.CustoHook;
        const isValueCustoHookRef = react_1.useRef(isValueCustoHook);
        if (isValueCustoHookRef.current !== isValueCustoHook) {
            isValueCustoHookRef.current = isValueCustoHook;
            throw new errors_1.HookChangeError("CustoHook must consistently return CustoHook or any value other than CustoHook. (path: " +
                path +
                "). Make sure to wrap your component with WrapInError helper function. Note: CRA still displays error in development mode; just press ESC do hide it");
        }
        return value;
    });
}
exports.buildCustoHook = buildCustoHook;
const useVl = (val, defaultValue, path) => {
    if (val === undefined && defaultValue !== undefined) {
        val = defaultValue;
    }
    if (!(val instanceof hook_1.CustoHook)) {
        const oldVal = val;
        const newVal = hook_1.CustoHook.createFn((() => oldVal));
        val = newVal;
    }
    const dependency = val instanceof hook_1.CustoHook ? val.unsafelyGetOriginalFn() : null;
    const dependencyRef = react_1.useRef(dependency);
    if (dependencyRef.current !== dependency) {
        // hook has been changed
        if (!(val instanceof hook_1.CustoHook) || !val.isSafe) {
            throw new errors_1.HookChangeError("hook changed in CustoHook. (path: " +
                path +
                "). Make sure to wrap your component with WrapInError helper function. Note: CRA still displays error in development mode; just press ESC do hide it");
        }
    }
    dependencyRef.current = dependency;
    return val;
};
